"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CtaButtonIcon = exports.CtaButtonText = exports.CtaButton = void 0;

var _tslib = require("tslib");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Button = _interopRequireDefault(require("../Button"));

var _Text = _interopRequireDefault(require("../Text"));

var _Box = _interopRequireDefault(require("../../Layout/Box"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var CtaButton = (0, _styledComponents.default)(_Button.default)(templateObject_1 || (templateObject_1 = (0, _tslib.__makeTemplateObject)(["\n  align-items: stretch;\n  border: none;\n  overflow: hidden;\n  cursor: pointer;\n  display: inline-flex;\n  font-family: ", ";\n  font-weight: bold;\n  justify-content: center;\n  margin: 0 auto;\n  padding: 0;\n  text-align: center;\n  text-decoration: none;\n  text-transform: uppercase;\n  line-height: 1em;\n\n  :hover {\n    background-color: black;\n  }\n"], ["\n  align-items: stretch;\n  border: none;\n  overflow: hidden;\n  cursor: pointer;\n  display: inline-flex;\n  font-family: ", ";\n  font-weight: bold;\n  justify-content: center;\n  margin: 0 auto;\n  padding: 0;\n  text-align: center;\n  text-decoration: none;\n  text-transform: uppercase;\n  line-height: 1em;\n\n  :hover {\n    background-color: black;\n  }\n"])), function (_a) {
  var theme = _a.theme;
  return theme.fonts.mrEaves;
});
exports.CtaButton = CtaButton;
CtaButton.displayName = 'CtaButton';
var CtaButtonText = (0, _styledComponents.default)(_Text.default)(templateObject_2 || (templateObject_2 = (0, _tslib.__makeTemplateObject)(["\n  align-self: center;\n  flex: 1 0 auto;\n"], ["\n  align-self: center;\n  flex: 1 0 auto;\n"])));
exports.CtaButtonText = CtaButtonText;
CtaButtonText.displayName = 'CtaButtonText';
var CtaButtonIcon = (0, _styledComponents.default)(_Box.default)(templateObject_3 || (templateObject_3 = (0, _tslib.__makeTemplateObject)(["\n  align-items: center;\n  display: inline-flex;\n"], ["\n  align-items: center;\n  display: inline-flex;\n"])));
exports.CtaButtonIcon = CtaButtonIcon;
CtaButtonIcon.displayName = 'CtaButtonIcon';
var templateObject_1, templateObject_2, templateObject_3;